import { useEffect, useState } from "react";
import useMainStore from "../stores/mainStore";

const MinRightContentWidth = 400;

function useIsLeftSidebarOverlay() {
    const [leftSidebarIsOverlay, setLeftSidebarIsOverlay] = useState(false);

    useEffect(() => {
        function resizeHandler(leftSidebarWidth_: number) {
            const rightWidth = window.innerWidth - leftSidebarWidth_;

            if (rightWidth < MinRightContentWidth) {
                setLeftSidebarIsOverlay(true);
            } else {
                setLeftSidebarIsOverlay(false);
            }
        }

        window.addEventListener("resize", () =>
            resizeHandler(useMainStore.getState().data.leftSidebarWidth)
        );
        resizeHandler(useMainStore.getState().data.leftSidebarWidth);

        return () => {
            window.removeEventListener("resize", () =>
                resizeHandler(useMainStore.getState().data.leftSidebarWidth)
            );
        };
    }, []);

    return leftSidebarIsOverlay;
}

export default useIsLeftSidebarOverlay;
